import {PayloadAction} from '@reduxjs/toolkit';

type param = {
    param:string;
    data:any
};

export const setParam = (state, action:PayloadAction<param>) => {
    const paramCode = action.payload.param;

    state[paramCode] = action.payload.data;
};